
export type NotificationSettingsFrequency = typeof NotificationSettingsFrequency[keyof typeof NotificationSettingsFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationSettingsFrequency = {
  IMMEDIATE: 'IMMEDIATE',
  DAILY_DIGEST: 'DAILY_DIGEST',
} as const;
